import { render, staticRenderFns } from "./DebtBill.vue?vue&type=template&id=10403c19&scoped=true"
import script from "./DebtBill.vue?vue&type=script&lang=js"
export * from "./DebtBill.vue?vue&type=script&lang=js"
import style0 from "./DebtBill.vue?vue&type=style&index=0&id=10403c19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10403c19",
  null
  
)

export default component.exports